import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvailableStatesMap } from 'state/static-data';
import { ApplicationState } from 'state/store/configureStore';
import { StateCode, VisitType } from 'state/types';
import { CustomerPreferenceState } from 'state/types/customer-preference';
import { getSelectedState, setSelectedState } from './storage';

export const FEATURE_NAME = 'customer-preference';
const CURRENT_STATE_EXPIRE_TIME = 7 * 24 * 60 * 60; // seconds
const CURRENT_STATE_COOKIE_NAME = "current-state";

const stateLocalStorageKey = "amzn1.katara.localStorage.location";
const state = getSelectedState()
const initialState: CustomerPreferenceState = {
  selectedStateCode: AvailableStatesMap[state ?? "_INVALID_STATE_"]?.stateCode,
  preferredVisitType: undefined
}

const slice = createSlice({
  name: FEATURE_NAME,
  initialState: initialState,
  reducers: {
    setSelectedStateCode(state, action: PayloadAction<StateCode>) {
      const stateCode = action.payload;
      state.selectedStateCode = stateCode;
      !!stateCode && setSelectedState(AvailableStatesMap[stateCode]);
    },
    setPreferredVisitType(state, action: PayloadAction<VisitType>) {
      const visitType = action.payload;
      state.preferredVisitType = visitType;
    },
  },
});

export const { setSelectedStateCode, setPreferredVisitType } = slice.actions;
export const selectCustomerPreferenceState = (state: ApplicationState): CustomerPreferenceState => state.customerPreferenceState;
export const selectSelectedStateCode = (state: ApplicationState): StateCode | undefined => state.customerPreferenceState.selectedStateCode

export default slice.reducer;
